import type { GameDetails, LobbyGame, Rule, Tag } from '../../_ui-core_/base/package/api/package/gaming/gaming-domain';

export function toGameStudioRule(gameStudioIds: string[]): Rule {
  return {
    left: 'gameStudioId',
    op: 'EQUALS',
    right: gameStudioIds,
  };
}

export function toThemeRule(themes: string[]): Rule {
  return {
    left: 'theme',
    op: 'EQUALS',
    right: themes,
  };
}

/**
 * Find tags by its names and filter out any undefined tags.
 */
function findTagsByNames(names: string[], allTags: Tag[]): Tag[] {
  const mappedTags: (Tag | undefined)[] = names.map((name) => {
    const tag = allTags.find((t) => t.name === name);
    if (tag === undefined) {
      window.$app.logger.warn(`No matching tag found for name: '${name}'`);
    }
    return tag;
  });
  return mappedTags.filter((tag) => tag !== undefined);
}

/**
 * Get a list of unique themes from the games and match them with the tags.
 */
export function getThemesFromGames(games: LobbyGame[] | GameDetails[], allTags: Tag[]): Tag[] {
  const uniqueNames = [...new Set(games.flatMap((game) => game.themes ?? []))];
  return findTagsByNames(uniqueNames, allTags);
}

/**
 * Get a list of unique features from the games and match them with the tags.
 */
export function getFeaturesFromGames(games: LobbyGame[] | GameDetails[], allTags: Tag[]): Tag[] {
  const uniqueNames = [...new Set(games.flatMap((game) => game.features ?? []))];
  return findTagsByNames(uniqueNames, allTags);
}

/**
 * Get a list of unique game studio ids from the games.
 */
export function getStudioIdsFromGames(games: LobbyGame[]): string[] {
  return [...new Set(games.flatMap((game) => game.gameStudioId ?? []))];
}
